<template>
  <Transition name="fade">
    <div
      v-if="bottomSheet"
      class="overlay"
      @click="closeBottomSheet()"
    />
  </Transition>

  <Transition :name="activeTransition">
    <div
      v-if="bottomSheet"
      :class="{
        'full-view': activeBottomSheet?.sheet.type === 'DEFAULT',
        'modal-view': activeBottomSheet?.sheet.type === 'MODAL',
      }"
    >
      <component
        :is="toRaw(bottomSheet)"
        v-bind="toRaw(componentProps)"
      />
    </div>
  </Transition>
</template>

<script setup lang="ts" generic="TProps">
import { ref, watch, toRaw, computed } from 'vue'
import {
  useBottomSheet,
  type componentType,
} from '../composables/bottom-sheet'

const { activeBottomSheet, closeBottomSheet } = useBottomSheet<TProps>()
const activeTransition = computed(
  () => activeBottomSheet.value?.sheet?.animationType,
)

const bottomSheet = ref<componentType | null>(null)
const componentProps = ref<TProps>()

watch(activeBottomSheet, (value) => {
  if (value) {
    bottomSheet.value = toRaw(value)?.sheet?.component
    if (value.props)
      componentProps.value = value.props
  }
  else {
    bottomSheet.value = null
  }
})
</script>

<style scoped>
.full-view{height:100vh;top:0}.full-view,.modal-view,.overlay{bottom:0;left:0;position:fixed;width:100vw;z-index:1000}.overlay{background-color:#000;height:100vh;opacity:.5;top:0}.slide-bottom-up-enter-active{transition:all .2s ease-out}.slide-bottom-up-leave-active{transition:all .2s cubic-bezier(1,.5,.8,1)}.slide-bottom-up-enter-from,.slide-bottom-up-leave-to{opacity:0;transform:translateY(100%)}.slide-enter-active{transition:all .2s ease-out}.slide-leave-active{transition:all .2s cubic-bezier(1,.5,.8,1)}.slide-enter-from,.slide-leave-to{opacity:0;transform:translateX(100%)}.slide-reverse-enter-active{transition:all .2s ease-out}.slide-reverse-leave-active{transition:all .2s cubic-bezier(1,.5,.8,1)}.slide-reverse-enter-from,.slide-reverse-leave-to{opacity:0;transform:translateX(-100%)}.fade-enter-active,.fade-leave-active{transition:opacity .3s ease-in-out}.fade-enter,.fade-leave-to{opacity:0}
</style>
